const NBA_SEASON = /^(\d{4})-(\d{2})$/;
const CALENDAR_YEAR = /^(\d{4})$/;

const expandEndYear = (start, yy) => {
  const century = Math.floor(start / 100) * 100;
  let end = century + yy;
  if (end < start) end += 100;
  return end;
};

export function parseYearKey(raw) {
  if (raw == null || raw === "") return null;
  const label = String(raw).trim();

  const nba = label.match(NBA_SEASON);
  if (nba) {
    const start = Number(nba[1]);
    const yy = Number(nba[2]);
    return { start, end: expandEndYear(start, yy), label };
  }

  const calendar = label.match(CALENDAR_YEAR);
  if (calendar) {
    const year = Number(calendar[1]);
    return { start: year, end: year, label };
  }

  return null;
}

export function compareYearKeys(a, b) {
  const left = parseYearKey(a);
  const right = parseYearKey(b);
  if (!left && !right) return String(a ?? "").localeCompare(String(b ?? ""));
  if (!left) return 1;
  if (!right) return -1;
  if (left.start !== right.start) return left.start - right.start;
  return left.end - right.end;
}

export function sortYearKeys(keys = [], direction = "asc") {
  const sorted = [...keys].sort(compareYearKeys);
  return direction === "desc" ? sorted.reverse() : sorted;
}
